export const initialGroupsTable = {
    data: [],
    loading: false
}

export const initialUsersNotInGroup = {
    data: [],
    loading: false
}